// installation-bridge.js
// Intercepts Add to Cart click, opens installation modal if installation add-on exists,
// sets the installation select, then re-triggers the original ATC click so the theme
// handles the actual /cart/add.js request (including its required { items: [...] } payload).

(function () {
  let bypassOnce = false;

  function closestContext(el) {
    return (
      el.closest("product-form") ||
      el.closest("form") ||
      el.closest(".product") ||
      el.closest("section") ||
      document
    );
  }

  function getInstallationModal(ctx) {
    return (
      ctx.querySelector?.("installation-modal") ||
      document.querySelector("installation-modal")
    );
  }

  function getInstallationSelect(ctx) {
    const scopedSelects =
      ctx.querySelectorAll?.("#custom_addon_variations select") || [];

    const selects =
      scopedSelects.length > 0
        ? scopedSelects
        : ctx.querySelectorAll?.("select") || [];

    for (const select of selects) {
      if (select.querySelector?.('option[data-label-name="Installation"]')) {
        return select;
      }
      const label = (select.dataset?.optionLabel || "").trim().toLowerCase();
      if (label === "installation") return select;
    }
    return null;
  }

  function setInstallationSelection(select, mode) {
    if (!select) return;

    const options = Array.from(select.options || []);
    if (!options.length) return;

    const find = (needle) =>
      options.find((o) => (o.textContent || "").toLowerCase().includes(needle));

    if (mode === "install") {
      const opt =
        find("white glove") ||
        find("installation") ||
        options[1] ||
        options[0];
      if (opt) select.value = opt.value;
      select.dispatchEvent(new Event("change", { bubbles: true }));
      return;
    }

    const opt =
      find("no installation") ||
      find("shipping only") ||
      find("no thanks") ||
      options[0];
    if (opt) select.value = opt.value;
    select.dispatchEvent(new Event("change", { bubbles: true }));
  }

  function retriggerATC(originalButton) {
    bypassOnce = true;
    originalButton?.click?.();
  }

  document.addEventListener(
    "click",
    function (e) {
      // Never intercept clicks inside the installation modal
      if (e.target.closest?.("installation-modal")) return;

      const btn = e.target.closest?.(
        "#add-to-cart, button#add-to-cart, [data-add-to-cart], button[name='add'], [type='submit'][name='add'], button[type='submit']"
      );
      if (!btn) return;

      // Extra safety: never treat modal buttons as ATC
      if (btn.closest?.("installation-modal")) return;
      if (btn.id === "install-btn" || btn.id === "dont-need") return;

      if (bypassOnce) {
        bypassOnce = false;
        return;
      }

      const ctx = closestContext(btn);
      const installSelect = getInstallationSelect(ctx);
      const modal = getInstallationModal(ctx);

      if (!installSelect || !modal?.open) return;

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      modal.open({
        onInstall: () => {
          setInstallationSelection(installSelect, "install");
          modal.close?.();
          retriggerATC(btn);
        },
        onNoInstall: () => {
          setInstallationSelection(installSelect, "no_install");
          modal.close?.();
          retriggerATC(btn);
        },
      });
    },
    true
  );
})();